<p-toast position='top-center'></p-toast>
<div *ngIf="isDownloading" class="overlay">
  <div class="spinner-container">
    <p-progressSpinner></p-progressSpinner>
    <h1>Exporting...</h1>
  </div>
</div>
<form (ngSubmit)="submit()" [formGroup]="form" class="form-container">
  <div class='home'>
    <div class="info">You have rights on these countries : {{ authorized_countries && authorized_countries.length ? authorized_countries : 'None' }} </div>
  </div>
  <h4>Download impacted prices (csv format)</h4>
  <div class="form-group">
    <label for="itemConstraintType" [escape]="false" pTooltip="FORBIDDEN_STORE_PRICE: Prices constraints refused" tooltipPosition="top">Constraint type</label>
    <select id="itemConstraintType" formControlName="constraintType">
      <option *ngFor="let type of itemConstraintType" [value]="type">
        {{ type }}
      </option>
    </select>
  </div>

  <div class="form-group">
    <label for="options" pTooltip="Maximum 500 elements allowed" tooltipPosition="top">Models and Items (Enter models or items split by comma)</label>
    <textarea id="options" formControlName="codes" placeholder="Enter models split by comma"></textarea>
  </div>

  <div class="form-group">
    <label for="tierCode" pTooltip="15 for country, 7 for store, then country / store number (Maximum 10 tier codes allowed)" tooltipPosition="top">Tier Codes (List of tier codes separated by comma)</label>
    <input id="tierCode" formControlName="tierCodes" type="text" placeholder="Format : 15_5_5, 15_3_3" />
  </div>

  <div class="form-group">
    <label for="startDate" pTooltip="Start date refers to the requested price creation date" tooltipPosition="top">Start date (refers to the creation date)</label>
    <input id="startDate" formControlName="startDate" type="date" />
  </div>

  <div class="form-group">
    <label for="endDate" pTooltip="End date refers to the requested price creation date" tooltipPosition="top">End date (refers to the creation date)</label>
    <input id="endDate" formControlName="endDate" type="date" />
  </div>

  <div class="form-group">
    <button type="submit" [disabled]="!form.valid || isDownloading">Export data</button>
  </div>
</form>

